export default __webpack_public_path__ + "static/raquette-sartoise-54a6a234257de1e7761beb901ff5223f.jpg";